// removed by extract-text-webpack-plugin
module.exports = {"row":"FormSettings__row___3FJuc","label":"FormSettings__label___1aUsg","input":"FormSettings__input___Ohe9V"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FormSettings/FormSettings.scss
// module id = 1183
// module chunks = 1